import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, isValidElement, useState, cloneElement, useMemo } from 'react';
import TabPane from './conferenceTabPane';
import ConferenceTabTitle from './conferenceTabTitle';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { setRootScrollTop } from '../../utils/dom';
var cls = 'conference-tab';
var ConferenceTab = function ConferenceTab(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls;
  var classes = createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls);
  var _useState = useState(0),
    currentIndex = _useState[0],
    setCurrentIndex = _useState[1];
  var clickHandler = function clickHandler(index) {
    setCurrentIndex(function () {
      return index;
    });
  };
  var validChildren = useMemo(function () {
    var tabPaneList = [];
    Children.forEach(children, function (child) {
      if ( /*#__PURE__*/isValidElement(child) && child.type === TabPane) {
        tabPaneList.push(child);
      }
    });
    return tabPaneList;
  }, [children]);
  useUpdateEffect(function () {
    setRootScrollTop(0);
  }, [currentIndex]);
  return _jsxs("div", Object.assign({
    className: classnames(classes, className)
  }, {
    children: [_jsx("div", Object.assign({
      className: classes + "-section"
    }, {
      children: validChildren.map(function (child, index) {
        return /*#__PURE__*/cloneElement(child, {
          currentIndex: currentIndex,
          index: index
        });
      })
    })), _jsx("div", Object.assign({
      className: classes + "-nav"
    }, {
      children: validChildren.map(function (child, index) {
        return _jsx(ConferenceTabTitle, {
          title: child.props.title,
          isActive: currentIndex === index,
          onClick: function onClick() {
            return clickHandler(index);
          },
          className: classes + "-title"
        }, index);
      })
    }))]
  }));
};
ConferenceTab.displayName = 'ConferenceTab';
export default ConferenceTab;